import { ClaudeTemplate } from "../types";
import { BASE, ENTER_ACCOUNT } from "./googleAdsShared";

/** Google Ads Demand Gen. */
export const googleAdsDemandGenTemplate: ClaudeTemplate = {
  ...BASE,
  id: "google-ads-demandgen",
  hierarchy:
    "Cuenta (MCC) → Customer account → Campaign (Demand Gen) → Ad groups → Ads",
  steps: `${ENTER_ACCOUNT}
### 2. Campaign Demand Gen
1. Busca la campaña **{{names.order}}**. Si existe, no la dupliques: entra y salta al paso 3.
2. Si no existe, "New campaign":
   - Objective según {{goal.kpi}} (CPM/CPV → Awareness and consideration; CPC → Website traffic; CPA/CPL → Sales o Leads).
   - Campaign type: **Demand Gen**.
   - Campaign name: {{names.order}}
   - Budget: diario = {{goal.budget}} / número de días entre {{goal.startDate}} y {{goal.endDate}} (redondea a la baja y dime el cálculo), o total de campaña si la cuenta lo permite.
   - Bidding: el que encaje con el objetivo (Maximize clicks, Target CPC en torno a {{goal.netUnitCost}}, Maximize conversions…). Si dudas, pregunta.
   - Start / end date: {{goal.startDate}} → {{goal.endDate}}.

### 3. Ad group
1. Ad group name: {{names.line}}
2. Locations: {{target.geography}} (país {{goal.country}}). Languages: {{target.language}}.
3. Audience: edad {{target.age}}, sexo {{target.gender}}, segmentos {{target.audience}}, intereses {{target.interests}}. Exclusiones: {{target.exclusions}}.
4. Channels: los que vengan por defecto (YouTube, Discover, Gmail…), salvo que las notas digan otra cosa. Devices: {{target.technology}}.

### 4. Ads
1. Formato según las piezas del bloque "Creatividades": imagen única, vídeo (URL de YouTube) o carrusel.
2. Titulares, descripciones, nombre de empresa ({{brand}}), logo y CTA: bloque "Copies". Final URL con UTM: bloque "URLs de destino".
3. Al terminar, **pausa la campaña** y avísame.
`,
};
